/* eslint-disable */
import axios from 'axios';
import { ADMIN_ROLE, CASE_CANCELLED, CASE_COMPLETED, CASE_STATUS_LEVEL_LOOKUP_TABLE, DOCUMENTATION_DRAFT, INITAL_REQUEST_DATA_READY } from '../constants';

export const disabledCountries = ['Canada', 'South Africa'];
export const pathsWithCanadaDisabled = [
  '/create-new-account',
  '/create-new-echannel',
  '/create-new-glsproduct',
  '/add-corporate-card',
  '/add-cash-flow-forecasting',
  '/capture-customer-details',
  '/create-new-address',
  '/sow-body/account',
  '/capture-product-notional-pooling',
  '/capture-product-interest-enhancement',
  '/create-new-other-account/',
  '/create-new-report-account',
  '/capture-product-echannel',
  '/capture-product-cashcon',
  '/create-new-product-echannel',
  '/capture-product-account'
];

export function camelCase(word) {
  return word.toLowerCase().replace(/\b[a-z](?=[a-z]{2})/g, (letter) => {
    return letter.toUpperCase();
  });
}

export function formApiUrl(_apiUrl, pathVarName, pathVarValue) {
  return _apiUrl.split(pathVarName).join(pathVarValue);
}

export function electOwningCase(cases) {
  const caseIds = Object.keys(cases);
  let owningCase;
  caseIds.forEach(caseId => {
    if (owningCase === undefined && cases[caseId].status !== CASE_CANCELLED) {
      // elect the case which is not cancelled
      owningCase = cases[caseId];
    }
  });
  //if all cases are cancelled pick the first added one
  if (!owningCase) {
    owningCase = cases[caseIds[0]];
  }
  return owningCase;
}

export function getProjectStatus(caseId, caseStatuses) {
  return (caseStatuses.filter(caseStatus => caseStatus.caseId === caseId))[0].status;
}

export function shouldDisableDocumentationTab(caseStatuses) {
  let shouldDisableDocumentationTab = true;
  caseStatuses.forEach(caseStatus => {
    if (CASE_STATUS_LEVEL_LOOKUP_TABLE[caseStatus.statusKey] > 1) {
      shouldDisableDocumentationTab = false;
    }
  });
  return shouldDisableDocumentationTab;
}

export function shoudlEnableGenerateDraftBtn(caseStatuses) {
  let shouldEnabledDraftGenerationBtn = false;
  caseStatuses.filter((item, index) => {
    if (item.statusKey === INITAL_REQUEST_DATA_READY || item.statusKey === DOCUMENTATION_DRAFT || item.generateDoc === true) {
      shouldEnabledDraftGenerationBtn = true;
    }
  })
  return shouldEnabledDraftGenerationBtn;
}

export function shoudlDisableCancelBtn(caseStatuses) {
  return (caseStatuses.length === 1 && (caseStatuses[0].statusKey === CASE_COMPLETED || caseStatuses[0].statusKey === CASE_CANCELLED));
}

export function shoudlDisableAllCaseBodyFooterBtns(caseStatuses) {
  return (caseStatuses.length === 1 && (caseStatuses[0].statusKey === CASE_CANCELLED));
}

export function formatEchannelResponse(echannelResponse) {
  const { newEchannel, other, profileOwner, otherProfileOwner, eChannelId } = echannelResponse;
  if (newEchannel === false) {
    if (!other) {
      echannelResponse.profileOwnerInPack = { ...profileOwner };
      // echannelResponse.profileOwner = undefined;
      echannelResponse.otherProfileOwner = undefined;
    } else {
      echannelResponse.otherEntityProfileOwner = { ...profileOwner };
      echannelResponse.profileOwnerInPack = undefined;
      echannelResponse.otherProfileOwner = undefined;
    }
  } else if (newEchannel === true) {
    echannelResponse.eChannelIdOptional = eChannelId;
  }
  return echannelResponse;
}

export function prepareEchannelPayload(echannel, caseId) {
  const { newEchannel, other, profileOwnerInPack, otherProfileOwner, otherEntityProfileOwner, swiftBIC } = echannel;
  if (newEchannel === false) {
    if (!other) {
      echannel.profileOwner = { ...profileOwnerInPack };
      echannel.profileOwnerInPack = undefined;
      echannel.otherProfileOwner = otherProfileOwner;
      echannel.caseId = echannel.profileOwner ? (echannel.profileOwner.value) : undefined;
    } else {
      echannel.profileOwner = otherEntityProfileOwner;
      echannel.otherProfileOwner = otherEntityProfileOwner !== undefined ? otherEntityProfileOwner.value === 'other' ? otherProfileOwner : undefined : otherProfileOwner;
      echannel.caseId = caseId;
      echannel.profileOwnerInPack = undefined;
      echannel.otherEntityProfileOwner = undefined;
    }
  } else {
    echannel.caseId = echannel.profileOwner ? echannel.profileOwner.value !== 'other' ? (echannel.profileOwner.value) : caseId : undefined;
    echannel.eChannelId = echannel.eChannelIdOptional;
    echannel.swiftBIC = echannel.eChannelType && echannel.eChannelType.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:swiftNet' ? swiftBIC : '';
  }

  return echannel;
}

export function shouldFireArtificialEventOnDropdown(dropdownName, dropdownType) {
  const ddNamesWhitelist = ["title", "eChannelType", "chequeBookTypes", "glsProductType", "communicationMedium", "paperStatementFrequency", "countryOfIncorporation", "countryOfRegistration", "businessSegment", "GdocsTerms", "productType", "status"];
  const ddTypesWhitelist = [];
  if (ddNamesWhitelist.includes(dropdownName)) {
    return true;
  }
  if (ddTypesWhitelist.includes(dropdownName)) {
    return true;
  }
  return false;
}

export function isAdmin(auth) {
  return safeGet(auth, "userDetails.roleDetails.role.value") === ADMIN_ROLE
}

export function loadIfStateAvailableInSessionStorage(ref, callback, fallback) {
  const _state = getPreviousPageStateFromSessionStorage();
  if (shouldLoadStateFromSessionStorage(ref.props.history) && _state !== undefined) {
    ref.setState(_state, () => {
      clearPageStateFromSessionStorage();
      // callback used as state changes are async
      if (callback && typeof (callback) === "function") {
        callback(ref.state);
      }
    });
    return true;
  } else {
    if (fallback && typeof (fallback) === 'function') {
      fallback();
    }
    return false;
  }
}

export function loadIfStateAvailableInSessionStorageLevel2(ref, callback, fallback) {
  const _state = getPreviousPageStateFromSessionStorageLevel2();
  if (shouldLoadStateFromSessionStorageLevel2(ref.props.history) && _state !== undefined) {
    ref.setState(_state, () => {
      clearPageStateFromSessionStorageLevel2();
      // callback used as state changes are async
      if (callback && typeof (callback) === "function") {
        callback(ref.state);
      }
    });
    return true;
  } else {
    if (fallback && typeof (fallback) === 'function') {
      fallback();
    }
    return false;
  }
}

function shouldLoadStateFromSessionStorageLevel2({ location }) {
  const savedPageStateString = window.sessionStorage.getItem("previousPageStateLevel2");
  const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) : undefined;
  if (savedPageState && savedPageState.prevSavedStatePath === location.pathname) {
    return true;
  } else {
    return false;
  }
}


function shouldLoadStateFromSessionStorage({ location }) {
  const savedPageStateString = window.sessionStorage.getItem("previousPageState");
  const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) : undefined;
  if (savedPageState && savedPageState.prevSavedStatePath === location.pathname) {
    return true;
  } else {
    return false;
  }
}

function getPreviousPageStateFromSessionStorage() {
  const savedState = window.sessionStorage.getItem("previousPageState");
  if (savedState !== undefined || savedState !== '') {
    return JSON.parse(window.sessionStorage.getItem("previousPageState"));
  } else {
    return undefined;
  }
}

function getPreviousPageStateFromSessionStorageLevel2() {
  const savedStateLevel2 = window.sessionStorage.getItem('previousPageStateLevel2');
  if (savedStateLevel2 !== undefined || savedStateLevel2 !== '') {
    return JSON.parse(window.sessionStorage.getItem("previousPageStateLevel2"));
  } else {
    return undefined;
  }
}

export function savePageStateInSessionStorage(state, pathname) {
  window.sessionStorage.setItem("previousPageState", JSON.stringify({ ...state, prevSavedStatePath: pathname }));
}

export function savePageStateInSessionStorageLevel2(state, pathname) {
  window.sessionStorage.setItem("previousPageStateLevel2", JSON.stringify({ ...state, prevSavedStatePath: pathname }));
}

export function clearPageStateFromSessionStorage() {
  window.sessionStorage.removeItem("previousPageState");
}
export function clearPageStateFromSessionStorageLevel2() {
  window.sessionStorage.removeItem("previousPageStateLevel2");
}


export function safeGet(obj, fieldPath, defaultReturnValue = "", splitter = ".") {
  var fields = fieldPath.split(splitter);
  for (var i = 0; i < fields.length; i++) {
    if (!obj || !obj.hasOwnProperty(fields[i])) {
      return defaultReturnValue;
    }
    if (i === fields.length - 1) {
      return obj[fields[i]];
    }
    obj = obj[fields[i]];
  }
}

export function getOrdinalSuffix(i) {
  var j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + "st";
  }
  if (j === 2 && k !== 12) {
    return i + "nd";
  }
  if (j === 3 && k !== 13) {
    return i + "rd";
  }
  return i + "th";
}
// Multilang
export function Translations(keyItem, lang, translatedData) {
  let flattened = {};
  if (keyItem !== undefined && keyItem !== null && typeof keyItem !== 'object') {
    var keyVal = keyItem.split('.')[0]

    if (keyVal === '~{UI') {
      switch (lang) {
        case 'English': {
          return translatedData.data[keyItem];
        }
        case 'Spanish': {
          return translatedData.data[keyItem];
        }
        case 'Bahasa': {
          return translatedData.data[keyItem];
        }
        default: {
          return flattened;
        }
      }
    } else {
      return keyItem
    }
  }
}

// Convert array

export function convertStringToArray(str) {
  if (str !== undefined && str !== '')
    return str.split('"')[1].split('[')[1].split(']')[0].split(',')
}

export function convertStringToArrayForRadio(str) {
  var array = []
  if (str !== undefined && str !== '') {
    var str1 = str.split('"')[3];
    var str2 = str.split('"')[7];
    array.push(str1);
    array.push(str2);
    if (str.split('"').length > 11 && str.split('"')[11]) {
      array.push(str.split('"')[11])
    }
    return array;
  }
}

// convert string to array for option
export function convertStringToArrayForOption(str) {
  if (str !== undefined && str !== '') {
    return str.split('"').filter(item => {
      if (item !== '' && item !== '[' && item !== ',' && item !== ']') {
        return item
      }
    })
  }
}


const langTran = {
  english: ['Complete', 'Incomplete', 'Optional'],
  spanish: ['Completo', 'Incompleto', 'Opcional'],
  bhasa: ['Selesai', 'Belum selesai', 'Opsional']
}

export function translateStatus(lang, statusVal) {
  if (lang === 'English') {
    if (statusVal === 'complete') {
      return langTran.english[0]
    } else if (statusVal === 'incomplete') {
      return langTran.english[1]
    } else if (statusVal === 'optional') {
      return langTran.english[2]
    }
  } else if (lang === 'Spanish') {
    if (statusVal === 'complete') {
      return langTran.spanish[0]
    } else if (statusVal === 'incomplete') {
      return langTran.spanish[1]
    } else if (statusVal === 'optional') {
      return langTran.spanish[2]
    }
  } else if (lang === 'Bahasa') {
    if (statusVal === 'complete') {
      return langTran.bhasa[0]
    } else if (statusVal === 'incomplete') {
      return langTran.bhasa[1]
    } else if (statusVal === 'optional') {
      return langTran.bhasa[2]
    }
  }
}

// check object is empty or not
export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false;
  }
  return true;
}

export function getRandomNumber(num) {
  return Math.ceil(Math.random() * num);
}

//Helper function for createDisplayString function
const isUpperCaseAt = (str, index) => {
  return str.charAt(index).toUpperCase() === str.charAt(index);
}

//This function takes in an object
// (e.g.{name:'Name',id:'Id',title:'Title',salutation:{title:'SalTitle'}})
//and a display key
// (e.g.[['salutation.title','name'],['title','name']])
//and returns an html string which can be rendered as normal HTML with line breaks etc.
// (e.g. `<b>SalTitle, Name</b><br/>Title, Name`)
export function createDisplayString(opt, displayKey) {
  let displayString = "";
  let i = -1;
  if (opt.defaultKey) {
    displayString += opt.displayKey;
  } else {
    for (let item of displayKey) {
      i = i + 1;
      for (let lineItem of item) {
        //for starts

        let splitForSpaces = lineItem.split(':');
        if (splitForSpaces.length > 1) {
          let _isString = false;
          for (let spaceItem of splitForSpaces) {
            let splitLineItem = spaceItem.split('.');
            if (splitLineItem.length > 1) {
              let displayPart = opt[splitLineItem[0]] || undefined;
              if (displayPart) {
                for (let p = 1; p < splitLineItem.length; p++) {
                  if (displayPart) {
                    displayPart = displayPart[splitLineItem[p]] || undefined;
                    if (splitLineItem[p] === 'name' && displayPart === 'Other') {
                      displayPart = opt[displayPart.toLowerCase()] || undefined;
                    }
                  } else {
                    break;
                  }
                }
              }
              displayString +=
                displayPart && displayPart.trim() !== ""
                  ? `${displayPart} `
                  : "";
              if (displayPart && displayPart.trim() !== "") {
                _isString = true;
              }
            } else {
              //Checking the first character of splitLineItem[0] for upper case as same is not a key of object but
              //static text that needs to be appended as it is -> e.g. 'Tel:telephone' -> ['Tel','telephone'] -> splitLineItem[0] is 'Tel' (not part of object key)
              if (!opt[splitLineItem[0]] && isUpperCaseAt(splitLineItem[0], 0)) {
                //Also check for this label's (e.g. 'Tel') value (e.g. 'telephone') in object.
                // If not present then label should not be shown.
                if (opt[splitForSpaces[1]] && opt[splitForSpaces[1]].trim() !== "") {
                  displayString += `${splitLineItem[0]}: `,
                    _isString = true;
                }
              } else {
                displayString +=
                  typeof opt[splitLineItem[0]] === 'string' && opt[splitLineItem[0]] && opt[splitLineItem[0]].trim() !== ""
                    ? `${opt[splitLineItem[0]]} `
                    : "";
                if (typeof opt[splitLineItem[0]] === 'string' && opt[splitLineItem[0]] && opt[splitLineItem[0]].trim() !== "") {
                  _isString = true;
                }
              }
            }
          }
          if (displayString && displayString.trim() !== '' && _isString) {
            displayString = displayString.trim() + ',';
          }
        } else {
          let splitLineItem = lineItem.split('.');
          if (splitLineItem.length > 1) {
            let displayPart = opt[splitLineItem[0]] || undefined;
            if (displayPart) {
              for (let p = 1; p < splitLineItem.length; p++) {
                if (displayPart) {
                  displayPart = displayPart[splitLineItem[p]] || undefined;
                  if (splitLineItem[p] === 'name' && displayPart === 'Other') {
                    displayPart = opt[displayPart.toLowerCase()] || undefined;
                  } else if (splitLineItem[0] === 'country' && (typeof opt['newEchannel'] === "boolean")) {
                    //This check appends New and Existing tags to eChannels e.g. in dropdown display
                    if (opt['newEchannel']) {
                      displayPart += ` (New)`;
                    } else {
                      displayPart += ` (Existing)`;
                    }
                  }
                } else {
                  break;
                }
              }
            }
            displayString +=
              displayPart && displayPart.trim() !== ""
                ? `${displayPart},`
                : "";
          } else {
            displayString +=
              opt[lineItem] && opt[lineItem].trim() !== ""
                ? `${opt[lineItem]},`
                : "";
          }
        }

        //for ends
      }

      //remove the trailing comma(if any)
      if (displayString.trim().substr(-1) === ",") {
        displayString = displayString.substring(0, displayString.length - 1);
      }
      if (
        i < displayKey.length - 1 &&
        displayString.slice(-5) !== "<br/>"
      ) {
        if (i === 0) {
          displayString = "<b>" + displayString + "</b>" + "<br/>";
        }
        else {
          if (displayString.trim() !== "") {
            displayString += "<br/>";
          }
        }
      }
    }
  }
  return { __html: displayString };
};

export async function cryptoPass(data,) {
  try {
    const response = await axios.get('/encrypt', { headers: { "x-encrypt": data } })
    return response.headers['x-encrypted']
  } catch (error) {
    console.log(error)
    return data
  }
}

//This function returns the length of Numbers appended at the end of a given string str; e.g. str='achAccountsId11' -> lenght-> 2 ('11')
export function getNumberLengthFromString(str) {
  let indexLen = 1;
  while (!isNaN(+(str.substring(str.length - indexLen)))) {
    indexLen += 1;
  }
  indexLen -= 1;
  return indexLen;
}

/* @description Decrypt the encrypted data with secret code*/
export async function decryptData(data,) {
  try {
    const response = await axios.get('/decrypt', { headers: { "x-decrypt": data } })
    return response.headers['x-decrypted']
  } catch (error) {
    console.log(error)
    return data
  }
}

export function setElementAttributes(elName, attrs, type = "id") {
  const elementMethod = { id: "getElementById", name: "getElementByName" }
  const elNode = typeof elName === "string" ? document[elementMethod[type]] && document[elementMethod[type]](elName) : elName
  if (elNode) {
    for (const key in attrs) {
      if (key === "remove") {
        for (const index in attrs[key]) {
          elNode.removeAttribute(attrs[key][index])
        }
      }
      else if (key === "style") {
        for (const styleAttr in attrs[key]) {
          elNode.style[styleAttr] = attrs[key][styleAttr]
        }
      }
      else {
        elNode.setAttribute(key, attrs[key]);
      }
    }
  }
}

export function isEmptyObject(value) {
  if (value) {
    if (Object.keys && value.constructor) {
      return Object.keys(value).length === 0 && value.constructor === Object
    }
    return (
      Object.prototype.toString.call(value) === '[object Object]' &&
      JSON.stringify(value) === '{}'
    )
  }
  return true
}

export function checkBoolean(value) {
  return ((typeof value === "string" && value.toLocaleLowerCase() === "true") || (typeof value === "boolean" && value === true))
}

export function checkJson(data, method = "parse") {
  if (method === "parse") {
    if (data && typeof data === "string") {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.log('json parse error', e);
        return null
      }
    }
  }
}

export function checkReportingToCFF(cffProductList, id) {
  if (Array.isArray(cffProductList) && cffProductList.length) {
    const flag = cffProductList.map(product => product.eChannelReporting.find(eChannelId => eChannelId === id)).filter(el => !!el).length
    return Boolean(flag)
  }
}

export function checkFalsyObject(object = {}) {
  return !(Object.values(object).filter(el => Array.isArray(el) ? el.length : typeof el === 'object' ? !isEmptyObject(el) : !!el).length)
}

export function getFalsyObject(object = {}) {
  let resetObject = {}
  Object.keys(object).map(key => {
    if (Array.isArray(object[key])) {
      resetObject[key] = []
    }
    else if (typeof object[key] === 'object') {
      resetObject[key] = {}
    }
    else {
      resetObject[key] = ''
    }
  })
  return isEmptyObject(resetObject) ? object : resetObject
}

export function removeEmptyObjectFromPayload(obj) {
  if (typeof obj === 'object') {
    for (let key in obj) {
      let curItem = obj[key];
      if (typeof curItem === 'object') {
        if (curItem instanceof Array) {
          if (curItem.length > 0) {
            curItem = curItem.filter(item => {
              if (typeof item === 'object') {
                if (item instanceof Array && item.length > 0) {
                  return item;
                } else if (Object.keys(item).length > 0) {
                  item = removeEmptyObjectFromPayload(curItem);
                  return item;
                }
              }
            });
          }
        } else {
          curItem = removeEmptyObjectFromPayload(curItem);
        }
      }
      obj[key] = curItem;
    }
  }
  return obj;
}

export function getStringToArray(string = '', lowerCase = false) {
  if (string) {
    return lowerCase ? string.split(",").map(product => product.trim().toLowerCase()) : string.split(",").map(product => product.trim())
  }
  return []
}

export function getArrayToString(array = [], unique = false, isArrayOfObject = false, key) {
  let value = [...array]
  if (isArrayOfObject && key) {
    value = array.map(el => el[key])
  }
  return unique ? Array.from(new Set(value)).join(", ") : value.join(", ")
}

export function deepCompareObject(obj1, obj2) {
  if (obj1 === null || obj1 === undefined || obj2 === null || obj2 === undefined) {
    return obj1 === obj2;
  }
  if (typeof obj1 !== typeof obj2) {
    return false;
  }
  if (typeof obj1 !== 'object') {
    return obj1 === obj2;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (!deepCompare(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}

export function deepCompareArray(arr1, arr2) {
  if (arr1 === null || arr1 === undefined || arr2 === null || arr2 === undefined) {
    return arr1 === arr2;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    if (!deepCompareObject(arr1[i], arr2[i])) {
      return false;
    }
  }
  return true;
}

export const throttle = (function () {
  let isThrottled = false;
  return function (func, delay = 500) {
    if (!isThrottled) {
      func && func();
      isThrottled = true;
      setTimeout(function () {
        isThrottled = false;
      }, delay);
    }
  };
})();

export function debounce(func = () => { }, delay = 200) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, delay);
  }
}

export function checkIsNA(value = '', retBool = false) {
  const condition = typeof value === "string" && value.trim().toLowerCase() === "n/a"
  return retBool ? Boolean(condition) : (condition ? "N/A" : value)
}

export async function getStaffConfig() {
  try {
    const response = await axios.get('/config')
    const { headers } = response
    return checkJson(headers['x-auth']) || {}
  } catch (error) {
    console.log(error)
  }
}

export function checkValueExistInObject(obj = {}, values = []) {
  return values.filter(value => Object.values(obj).indexOf(value) > -1).length
}

export const toggleClass = (elementId, className, condition) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.classList.toggle(className, condition);
  }
};

export function getConcatenatedStringFromValues(...values) {
  return values.filter(value => !!value).join(this && this.separator ? this.separator : ', ');
}


export const currentNodeEnvironment = () => {
  const envMap = {
    development: 'dev',
    production: 'prod',
    test: 'test',
  };
  return envMap[process.env.NODE_ENV] || 'unknown';
};

export const isProductionEnvironment = () => {
  const env = process.env.NODE_ENV;
  return env === 'production';
}

export const consoleLog = (message = '', logType = 'log', logInProd = false, ...additionalData) => {
  // Suppress logs in production unless explicitly allowed (logInProd is true)
  if (currentNodeEnvironment() === 'prod' && !logInProd) return; // Early return if NODE_ENV is production and logInProd is false

  message = typeof message === 'string' ? message : JSON.stringify(message); // Normalize the message to string if user passes an object or array, etc.

  const validLogTypes = ['error', 'warn', 'info', 'log'];
  logType = validLogTypes.includes(logType) ? logType : 'log'; // Normalize the log type to 'log' if invalid

  const timestamp = new Date().toLocaleString();

  const additionalInfoText = additionalData.length > 0
    ? '\n\n[ADDITIONAL INFORMATION]:'
    : ''

  const styles = {
    error: 'color: black; background-color: #FFB3B3; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
    warn: 'color: black; background-color: #FFF5BA; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
    info: 'color: black; background-color: #B3D9FF; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
    log: 'color: black; background-color: #B3FFCC; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
  };
  const style = styles[logType] || styles.log;
  const timestampStyle = 'color: white; background-color: #191919; font-weight: normal; padding: 2px 8px; border-radius: 24px; margin-left: 16px';
  const additionalInfoStyle = 'font-style: italic;'

  switch (logType) {
    case 'error':
      console.error(`%c[ERROR]: ${message}%c${timestamp}%c${additionalInfoText}`, style, timestampStyle, additionalInfoStyle, ...additionalData);
      break;
    case 'warn':
      console.warn(`%c[WARNING]: ${message}%c${timestamp}%c${additionalInfoText}`, style, timestampStyle, additionalInfoStyle, ...additionalData);
      break;
    case 'info':
      console.info(`%c[INFO]: ${message}%c${timestamp}%c${additionalInfoText}`, style, timestampStyle, additionalInfoStyle, ...additionalData);
      break;
    default:
      console.log(`%c[LOG]: ${message}%c${timestamp}%c${additionalInfoText}`, style, timestampStyle, additionalInfoStyle, ...additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js